var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getSignatureReferenceForAccountId } from "@rentiohq/shared-frontend/dist/redux/templateDocument/templateDocument.utils";
import uniq from "lodash/uniq";
import { EDefaultGroupId, EDefaultVariableId, } from "../TemplateEditor/components/Editor/Editor.config";
import { EVariableType, } from "../TemplateEditor/components/Editor/Editor.types";
import { getTenantEditableVariableIds } from "../TemplateEditor/components/Editor/Editor.utils";
export var getSignerFields = function (params) {
    var _a;
    var fields = params.fields, variablesData = params.variablesData;
    var filterOutBrokerSignature = false;
    var filterOutOwnerSignatures = false;
    var brokerIsSignerOnBehalfOfOwnersVariable = fields.variables.find(function (x) { return x.id === EDefaultVariableId.BrokerIsSignerOnBehalfOfOwners; });
    if (brokerIsSignerOnBehalfOfOwnersVariable) {
        var variableData = (_a = variablesData[brokerIsSignerOnBehalfOfOwnersVariable.id]) === null || _a === void 0 ? void 0 : _a[0];
        var brokerIsSignerOnBehalfOfOwners = variableData === true;
        filterOutBrokerSignature = !brokerIsSignerOnBehalfOfOwners;
        filterOutOwnerSignatures = brokerIsSignerOnBehalfOfOwners;
    }
    var variablesAsSignature = fields.variables.filter(function (x) { return x.type === EVariableType.Signature; });
    var result = {};
    variablesAsSignature.forEach(function (variable) {
        // variableData should be array of account ID's
        var variableData = variablesData[variable.id];
        // Filter owner signature if broker signs on behalf of owners
        if (filterOutOwnerSignatures) {
            var group = fields.groups.find(function (x) { return variable.groupId === x.id; });
            if ((group === null || group === void 0 ? void 0 : group.id) === EDefaultGroupId.Owner) {
                return;
            }
        }
        // Filter broker signature if broker does not sign on behalf of owners
        if (filterOutBrokerSignature) {
            var group = fields.groups.find(function (x) { return variable.groupId === x.id; });
            if ((group === null || group === void 0 ? void 0 : group.id) === EDefaultGroupId.Broker) {
                return;
            }
        }
        variableData.forEach(function (accountId) {
            if (typeof accountId === "number") {
                result[accountId] = getSignatureReferenceForAccountId(accountId);
            }
        });
    });
    return result;
};
/**
 * The record the template document editor saves.
 *
 * A broker save writes the whole record: the broker edits the body, the fields
 * and every variable. The external tenant submit carries the tenant's own
 * answers and nothing else - the tenant can only fill in the variables the
 * template marks `editableByTenant` (`getTenantEditableVariableIds`), so the
 * body, the fields, the document config, the signer fields and the broker's own
 * variables stay at the record the editor last fetched instead of being
 * rewritten from the copy the browser holds.
 *
 * This is hardening, not a demonstrated repair of the SUP-4329 photo loss. The
 * tenant's PATCH used to be able to replace every field from its own copy, and
 * a broker's photo references live in the broker's image variables inside
 * `variablesData`, so that write was in the blast radius. Nobody has traced a
 * client path that actually drops such a reference, and the observed photo loss
 * is addressed server-side, so do not read this branch as closing that half of
 * the ticket.
 */
export var getTemplateDocumentUpdateData = function (params) {
    var isExternalTenantSubmit = params.isExternalTenantSubmit, stored = params.stored, submitted = params.submitted;
    var documentIds = uniq(__spreadArray(__spreadArray([], stored.documentIds, true), submitted.documentIds, true));
    if (isExternalTenantSubmit) {
        var variablesData_1 = __assign({}, stored.variablesData);
        // Which variables the tenant owns is read from the stored fields: the
        // submitted ones come from the same browser as the values.
        getTenantEditableVariableIds(stored.fields).forEach(function (variableId) {
            // Present but empty is the tenant clearing an answer, so the key has to
            // be carried over on its own presence rather than on a filled-in value.
            if (variableId in submitted.variablesData) {
                variablesData_1[variableId] = submitted.variablesData[variableId];
            }
        });
        return {
            documentIds: documentIds,
            variablesData: JSON.stringify(variablesData_1),
        };
    }
    return {
        data: JSON.stringify(submitted.data),
        fields: JSON.stringify(submitted.fields),
        variablesData: JSON.stringify(submitted.variablesData),
        documentConfig: JSON.stringify(submitted.documentConfig),
        documentIds: documentIds,
        signerFields: getSignerFields({
            fields: submitted.fields,
            variablesData: submitted.variablesData,
        }),
    };
};
